export default __webpack_public_path__ + "static/media/sphere.8641b227.gif";